import { CategoryLocaleCodes } from './categories.model';

export enum BlogCategoriesEndpoints {
  LIST = '/blog/categories',
  CATEGORY = '/blog/category',
}

export interface IBlogCategoryLocaleFields {
  name: string;
  slug?: string;
}

export type IBlogCategoryLocaleMap = Partial<Record<CategoryLocaleCodes, IBlogCategoryLocaleFields>>;

export interface IBlogCategorySaveLocaleFields {
  name: string;
}

export interface IBlogCategory {
  id: string;
  position: number;
  locale: IBlogCategoryLocaleMap;
}

export interface IBlogCategorySaveDTO {
  position: number;
  locale: Record<string, IBlogCategorySaveLocaleFields>;
}

export interface IBlogCategoriesListResponse {
  data: IBlogCategory[];
}

export interface IBlogCategoryResponse {
  data: IBlogCategory;
}

export interface IDeleteBlogCategoryResponse {
  data: {
    success: boolean;
  };
}
